// extracted by mini-css-extract-plugin
export default {"pickerWrap":"pickerWrap--GScBC","shortcuts":"shortcuts--ePjF_","darkText":"darkText--Z9o5s","timeFramePlaceholder":"timeFramePlaceholder--XvRrO"};